<template>
  <div class="row">
    <!-- Duże ekrany -->
    <div class="col-md-12 btn-group d-none d-md-flex">
      <Link v-if="hasPermission('canViewService')" :href="route('service.show', { id: service.id })"
            class="btn btn-outline-primary" :class="{ 'btn-primary': isRouteActive('service.show') }">Zgłoszenie
      </Link>
      <Link v-if="hasPermission('canViewServiceFiles')" :href="route('service.showattch', { id: service.id })"
            class="btn btn-outline-primary" :class="{ 'btn-primary': isRouteActive('service.showattch') }">Pliki
        zgłoszenia
      </Link>
      <Link v-if="hasPermission('canViewServiceCosts')" :href="route('service.costs', { id: service.id })"
            class="btn btn-outline-primary" :class="{ 'btn-primary': isRouteActive('service.costs') }">Kosztorys
      </Link>
      <Link v-if="hasPermission('canEditService')" :href="route('service.protocol', { id: service.id })"
            class="btn btn-outline-primary" :class="{ 'btn-primary': isRouteActive('service.protocol') }">Edytor
        protokołu
      </Link>
      <Link v-if="hasPermission('canServicePDF')" :href="route('service.showprotocolattch', { id: service.id })"
            class="btn btn-outline-primary" :class="{ 'btn-primary': isRouteActive('service.showprotocolattch') }">Pliki
        protokołu
      </Link>
      <Link v-if="hasPermission('canServicePDF')" :href="route('service.showservicesattch', { id: service.id })"
            class="btn btn-outline-primary" :class="{ 'btn-primary': isRouteActive('service.showservicesattch') }">Pliki
        serwisu
      </Link>
    </div>

    <!-- Małe ekrany -->
    <div class="col-12 d-md-none">
      <div class="dropdown">
        <button class="btn btn-outline-primary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                type="button" @click="toggleDropdown">
          {{ activeLabel }}
          <i class="bi bi-list ms-2"></i>
        </button>
        <div class="dropdown-menu w-100" :class="{ show: isDropdownOpen }">
          <Link v-if="hasPermission('canViewService')" :href="route('service.show', { id: service.id })"
                class="dropdown-item" :class="{ 'active': isRouteActive('service.show') }">Zgłoszenie
          </Link>
          <Link v-if="hasPermission('canViewServiceFiles')" :href="route('service.showattch', { id: service.id })"
                class="dropdown-item" :class="{ 'active': isRouteActive('service.showattch') }">Pliki zgłoszenia
          </Link>
          <Link v-if="hasPermission('canViewServiceCosts')" :href="route('service.costs', { id: service.id })"
                class="dropdown-item" :class="{ 'active': isRouteActive('service.costs') }">Kosztorys
          </Link>
          <Link v-if="hasPermission('canEditService')" :href="route('service.protocol', { id: service.id })"
                class="dropdown-item" :class="{ 'active': isRouteActive('service.protocol') }">Edytor protokołu
          </Link>
          <Link v-if="hasPermission('canServicePDF')" :href="route('service.showprotocolattch', { id: service.id })"
                class="dropdown-item" :class="{ 'active': isRouteActive('service.showprotocolattch') }">Pliki protokołu
          </Link>
          <Link v-if="hasPermission('canServicePDF')" :href="route('service.showservicesattch', { id: service.id })"
                class="dropdown-item" :class="{ 'active': isRouteActive('service.showservicesattch') }">Pliki serwisu
          </Link>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, computed} from "vue";
import route from "../../../../vendor/tightenco/ziggy/src/js/index.js";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";

const props = defineProps({
  service: {
    type: Object,
    required: true,
  }
});

const {hasPermission} = usePermission();
const isDropdownOpen = ref(false);

const toggleDropdown = () => {
  isDropdownOpen.value = !isDropdownOpen.value;
};

const isRouteActive = (routeName) => {
  return route().current(routeName);
};

// mapa tras -> etykiety
const labels = {
  "service.show": "Zgłoszenie",
  "service.showattch": "Pliki zgłoszenia",
  "service.costs": "Kosztorys",
  "service.protocol": "Edytor protokołu",
  "service.showprotocolattch": "Pliki protokołu",
  "service.showservicesattch": "Pliki serwisu",
};

// computed: nazwa aktywnej etykiety
const activeLabel = computed(() => {
  const current = route().current();
  return labels[current] || "Menu";
});
</script>
